import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { useCRMTable } from './hooks/useCRMTable';
import { customStylesCrm } from '../../../util/TableStyles';
import { noDataComponent, filterCrm } from '../../../util/DataObject';
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton, Button } from '@albo-ui/core';
import { Box, IconButton, MenuItem, TextField, FormControl, Tab, Tabs, InputAdornment } from '@mui/material';
import { Search, SupportAgent, Clear } from '@mui/icons-material';
import { CRMLeadProps } from './types';
import { CRMAnalistsAdmin } from './CRMAnalistAdmin';
import { CRMCreateRegister } from '../../modals/leads-crm/CRMCreateRegister';
import { CRMDeals } from './CRMDeals';
import CustomPagination from '../../elements/CustomPagination';
import { CRMGroupDetail } from '../../modals/leads-crm/CRMGroupDetail';
import { ItemConfirmDialog } from '../../modals/confirm';

export const CRMTable = ({ changeAlert, changeLoader, changeWidgets, sectionData, config, crmType, catalogs, selectedSection, forms, crmContactFlow }: CRMLeadProps) => {    
    const { data, form, formFind, columns, loading: loadingTable, tabActive, tabs, platformInfo, platformData, ctFunnel, revenueData, pagination, agentList, showDetail, groupDetail, showMenu, row, dialogConfirm, dialogText, selectedTab, segments, companyGroups, setTabActive, getData, saveData, saveRequest, crmFilter, onHandleChange, onHandleChangeFind, changeTab, clearInput, getLeadByUuid, getRevenue, changePage, handleChangeRowsPerPage, onCloseDetail, openMenu, closeMenu, onDeleteCompany, onConfirmDialog, onCloseDialog, setSelectedTab } = useCRMTable(changeAlert, changeWidgets, config)
    const { theme } = useThemeProvider();

    useEffect(() => {
        saveRequest(crmType)
        selectedSection ? setTabActive(selectedSection) : setTabActive(tabActive)
        setSelectedTab(selectedSection === "contact" ? `${selectedSection}-${crmContactFlow}` : selectedSection);
        sectionData ? saveData(sectionData) : changeTab(selectedSection || tabActive, forms ? forms["form"] : null, crmContactFlow)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);
      
    return (
        <>
            <CRMAnalistsAdmin changeAlert={changeAlert} changeLoader={changeLoader} crmType={crmType}/>
            <Card padding={4} flexDirection='column' fullWidth fullHeight alignItems='stretch' justifyContent='space-between' style={{ borderColor: theme.colors.manatee, marginTop: 3 }}> 
                <FlexGrid container fullWidth justify='space-between'>

                {loadingTable ? 
                    <Skeleton width='100%' height='100px' style={{marginTop: 20}} />
                    :
                    <>
                    <FlexGrid item fullWidth>
                        <Typography variant='h2' style={{display: 'flex', alignItems: 'center', fontSize: '1.2rem'}}>
                            <SupportAgent sx={{ marginRight: 1 }}/> Centro de Leads
                        </Typography>
                        <Box my={1} sx={{ fontStyle: 'italic', fontWeight: '500 !important' }}>
                            {pagination.totalDocuments} registro(s)
                        </Box>
                    </FlexGrid>
                    {tabActive !== 'panel' &&
                    <Box>
                        <FlexGrid container spacing={2} style={{justifyContent: 'right'}} fullWidth >
                            <TextField select value={formFind["filters"]['type'] || -1} onChange={onHandleChangeFind.bind(this, "type", null)} defaultValue={-1} size='small' sx={{minWidth: 150, maxWidth: 160,}} color='secondary' fullWidth >
                                <MenuItem value={-1} disabled>Tipo de dato</MenuItem>
                                    {filterCrm.map((i) => {
                                        return i.tab === tabActive && <MenuItem key={i.key} value={i.key}>{i.label}</MenuItem>
                                    })}
                            </TextField>
                            {formFind["filters"]['type'] === 'name' ?
                                <>
                                <TextField
                                    label={'Nombres'} value={(formFind["filters"]['keyword'] && formFind["filters"]['keyword']['gname']) || ''} color='secondary' size='small' fullWidth 
                                    InputProps={{style: {height: 40}}} 
                                    onChange={onHandleChangeFind.bind(this, 'keyword', 'gname')}
                                />
                                <TextField
                                    label={'Apellidos'} value={(formFind["filters"]['keyword'] && formFind["filters"]['keyword']['lname']) || ''} color='secondary' size='small' fullWidth 
                                    InputProps={{
                                        style: {height: 40},
                                        endAdornment: (
                                            formFind["filters"]['keyword'] && <InputAdornment position="end">
                                                <IconButton onClick={clearInput.bind(this)} edge="end">                
                                                    <Clear />
                                                </IconButton> 
                                            </InputAdornment>
                                        ),
                                    }} 
                                    onChange={onHandleChangeFind.bind(this, 'keyword', 'lname')}
                                />
                                </>
                                :
                                <TextField
                                    label={'Ingrese un dato de búsqueda...'} value={formFind["filters"]['keyword'] || ''} color='secondary' size='small' fullWidth 
                                    InputProps={{
                                        style: {height: 40, minWidth: 350},
                                        endAdornment: (
                                            formFind["filters"]['keyword'] && <InputAdornment position="end">
                                                <IconButton onClick={clearInput.bind(this)} edge="end">                
                                                    <Clear />
                                                </IconButton> 
                                            </InputAdornment>
                                        ),
                                    }} 
                                    onChange={onHandleChangeFind.bind(this, 'keyword', null)}
                                />
                            }
                            <Button onClick={openMenu.bind(this, null)} style={{minWidth: 140, maxWidth: 140, height: 40}}>Crear {tabActive === 'company'? "Deal" : tabActive === 'contact' ? "Lead" : "Grupo Empresarial"}</Button>

                        </FlexGrid>
                        <FlexGrid container spacing={2} style={{paddingTop: 15, justifyContent: 'right'}} fullWidth>
                            {tabActive === 'company' && <TextField select value={form["filters"]['low_funnel'] || -1} onChange={onHandleChange.bind(this, "low_funnel", null)} defaultValue={-1}  size='small' color='secondary' style={{width: "inherit"}}>
                                <MenuItem value={-1} disabled>Etapa del flujo</MenuItem>
                                <MenuItem value={''} >Todos</MenuItem>
                                {platformData && platformData['crmLowFunnel'].map((item) => (
                                    <MenuItem key={`funnel-${item.key}`} value={item.key}>{item.label}</MenuItem>
                                ))}
                            </TextField>}

                            <TextField select value={form["filters"]['agent'] || -1} onChange={onHandleChange.bind(this, "agent", null)} defaultValue={-1}  size='small' color='secondary' style={{minWidth: 160}}>
                                <MenuItem value={-1} disabled>Agente</MenuItem>
                                <MenuItem value={''} >Todos</MenuItem>
                                {agentList && agentList.map((item) => (
                                    <MenuItem key={`agent-${item.uuid}`} value={item.uuid}>{item.name}</MenuItem>
                                ))}
                            </TextField>
                            {tabActive === 'contact' && <TextField select value={form["filters"]['status'] || -1} onChange={onHandleChange.bind(this, "status", null)} defaultValue={-1} fullWidth size='small' color='secondary' style={{minWidth: 140}}>
                                <MenuItem value={-1} disabled>Estatus</MenuItem>
                                <MenuItem value={''} >Todos</MenuItem>
                                {platformData && platformData[`${tabActive}Status`].map((item) => (
                                    <MenuItem key={`status-${item.key}`} value={item.key}>{item.label}</MenuItem>
                                ))}
                            </TextField>}
                            {tabActive === 'contact' && <TextField select value={form["filters"]['tracking_status'] || -1} onChange={onHandleChange.bind(this, "tracking_status", null)} defaultValue={-1} fullWidth size='small' color='secondary' style={{minWidth: 140}}>
                                <MenuItem value={-1} disabled>Seguimiento</MenuItem>
                                <MenuItem value={''} >Todos</MenuItem>
                                {platformData && platformData['trackingStatus'].map((item) => (
                                    <MenuItem key={`tracking-${item.key}`} value={item.key}>{item.label}</MenuItem>
                                ))}
                            </TextField>}
                            {tabActive !== "company_group" && <FlexGrid item style={{width: "auto"}}>
                                <FormControl color='secondary' fullWidth >
                                <TextField
                                    value={form["filters"]["dates"]["start"]}
                                    onChange={onHandleChange.bind(this, 'dates', 'start')}
                                    label="Fecha inicio"
                                    size="small"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{style: {height: 40}}} 
                                />
                                </FormControl>
                            </FlexGrid>}

                            {tabActive !== "company_group" && <FlexGrid item style={{width: "auto"}}>
                                <FormControl color='secondary' fullWidth>
                                <TextField
                                    value={form["filters"]["dates"]["end"]}
                                    onChange={onHandleChange.bind(this, 'dates', 'end')}
                                    label="Fecha fin"
                                    size="small"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{style: {height: 40}}} 
                                />
                                </FormControl>
                            </FlexGrid>}
                            <IconButton onClick={crmFilter.bind(this)} sx={{padding: '0 !important'}}><Search sx={{padding: '7px', borderRadius: 2, boxSizing: 'content-box', color: 'white', backgroundColor: '#8bc179' }}/></IconButton>
                        </FlexGrid>
                    </Box>
                    }
                    </>
                }

                </FlexGrid>
                {loadingTable ? 
                    <Skeleton width='100%' height='100px' style={{marginTop: 20}} />
                    :
                    <>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={2} mt={4}>
                            <Tabs value={tabActive === "contact" ? `${tabActive}-${selectedTab || crmContactFlow}` : tabActive} indicatorColor='secondary' textColor='secondary' >
                                {tabs.map((item, index) => {
                                    return <Tab key={index} label={item.title} value={item.type ? `${item.name}-${item.type}` : item.name} onClick={changeTab.bind(this, item.name, null, item['type'])} sx={{textTransform: 'none', fontWeight: 700, fontFamily: 'Muli,sans-serif', fontSize: 14}} />
                                })}
                            </Tabs>
                        </Box>
                        {tabActive !== "company" ?
                            <FlexGrid container style={{margin: '25px 0' }} direction='column'>
                                {
                                    loadingTable ?
                                        <Skeleton width='100%' height='100px' />
                                        :
                                        <>
                                        <DataTable
                                            columns={columns}
                                            data={data}
                                            customStyles={customStylesCrm}
                                            noDataComponent={noDataComponent}
                                            progressPending={loadingTable}
                                            expandOnRowClicked={false}
                                        />
                                        <CustomPagination 
                                            rows={pagination.totalDocuments}
                                            page={pagination.page - 1}
                                            rowsPerPage={pagination.rowsPerPage}
                                            handleChangePage={changePage}
                                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                                        />
                                        </>

                                }
                            </FlexGrid>
                            :
                            loadingTable ?
                                <Skeleton width='100%' height='100px' />
                                :     
                                <CRMDeals 
                                    sectionData={data}
                                    ctFunnel={ctFunnel}
                                    form={form}
                                    columns={platformData["crmLowFunnel"]}
                                    tabActive={tabActive}
                                    getData={getData}
                                    getLeadByUuid={getLeadByUuid}
                                    changeAlert={changeAlert}
                                    revenueData={revenueData}
                                    getRevenue={getRevenue}
                                    pagination={{
                                        ...pagination,
                                        onChangePage: changePage,
                                        onChangeRowsPerPage: handleChangeRowsPerPage
                                    }}
                                />

                        }
                    </>
                }
            </Card>
            
            <CRMCreateRegister 
                changeAlert={changeAlert}
                changeLoader={changeLoader}
                config={config}
                sectionData={groupDetail}
                formSelected={tabActive === 'company' ? platformData && platformInfo[1][platformData['createCompany']] : tabActive === 'contact' ? platformData && platformInfo[0][platformData['createContact']] : platformData && platformInfo[2][platformData['createCompanyGroup']]}
                platformData={platformData}
                platformInfo={platformInfo}
                selectedSection={tabActive}
                open={showMenu}
                onClose={closeMenu}
                catalogs={catalogs}
                getData={changeTab}
                crmContactFlow={crmContactFlow}
                crmType={crmType}
                segments={segments}
                companyGroups={companyGroups}
            />

            <CRMGroupDetail
                data={groupDetail}
                open={showDetail}
                onClose={onCloseDetail}
                onDeleteCompany={onDeleteCompany}
            />

            <ItemConfirmDialog 
                open={dialogConfirm.open}
                title={dialogText["title"]}
                message={dialogText["message"]}
                onClose={onCloseDialog} 
                onConfirm={onConfirmDialog.bind(this)} 
                item={row && row["group_name"]}
            />
            
        </>
    )
};